export default __webpack_public_path__ + "static/digilock-americas-f1df04a492f8008b4b377ebd4c7ada5c.jpg";